// import { Calendar } from "feather-icons-react/build/IconComponents";
import React, { useState, useEffect } from "react";
import CountUp from "react-countup";
// import "bootstrap-daterangepicker/daterangepicker.css";
// import DateRangePicker from "react-bootstrap-daterangepicker";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Link, useNavigate } from "react-router-dom";
import Axios from "axios";
import {
  API_BASE_URL,
  GET_DDL,
  GET_STORE_DASHBOARD,
  GET_LATE_INDENT_REQ,
  GET_USER_PERMISSIONS,
  GET_USER_STORES,
  GET_INDENT_BTN_STATUS,
  GET_DASHBOARD_TABLES_DATA,
  // INSERT_LATE_INDENT_REQ
} from "../../Config";
import NoOfStores from "./noofstores.svg";
import Purchase from "./purchase.svg";
import Supplier from "./supplier.svg";
// import Sales from './sales.svg';
import StockValue from "./stockvalue.svg";
// import Select from "react-select";
// import { DatePicker
// Space,
// Typography
//  } from 'antd';
// import Swal from "sweetalert2";
// import moment from 'moment';
import { Popover, Table, Spin } from "antd";
import ApplyLateIndentReq from "./lateindentrequestapply";
import SpinLoader from "../loader/SpinLoader";

const StoreDashboard = () => {
  const [userDataSession, setUserDataSession] = useState([]);
  const [dashboardData, setDashboardData] = useState([]);
  const [dashboardCounts, setDashboardCounts] = useState([]);
  const [inventoryData, setInventoryData] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedStoreId, setSelectedStoreId] = useState(
    sessionStorage.getItem("selectedStoreId")
  );
  const [storeData, setStoreData] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);
  const navigate = useNavigate();
  // const [reason, setReason] = useState("");
  // const [dates, setDates] = useState([]);
  // const [lateReqSubLoading, setLateReqSubLoading] = useState(false);
  const [addBtnStatus, setAddBtnStatus] = useState(null);
  const [lateIndentReqsLoading, setLateIndentReqsLoading] = useState(false);
  const [lateIndentReqs, setLateIndentReqs] = useState([]);

  // const { RangePicker } = DatePicker;

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      Axios.get(
        `${API_BASE_URL}${GET_USER_STORES}?OrgId=${userDataSession.OrgId}&UserId=${userDataSession.UserId}`
      )
        .then((response) => {
          if (response.data) {
            setStoreData(response.data.ResultData);
          } else {
            console.error("Error fetching data:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);

  useEffect(() => {
    if (storeData.length === 1) {
      const selectedStoreObj = {
        value: storeData[0].StoreId,
        label: storeData[0].Name,
      };
      setSelectedStore(selectedStoreObj);
    }
  }, [storeData]);

  useEffect(() => {
    console.log(
      selectedStore?.value,
      "selectedStoreselectedStoreselectedStoreselectedStore"
    );
    if (userDataSession && userDataSession.OrgId && selectedStore) {
      Axios.get(
        `${API_BASE_URL}${GET_INDENT_BTN_STATUS}?OrgId=${userDataSession.OrgId}&StoreId=${selectedStore?.value}`
      )
        .then((response) => {
          if (response.data) {
            console.log(response.data, "response of IsIndentDayToday");
            setAddBtnStatus(response.data.ResultData[0].IsIndentDayToday);
          } else {
            console.error("Error fetching data:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession, selectedStore]);

  const fetchLateIndents = () => {
    if (userDataSession && userDataSession?.OrgId && userDataSession?.UserId) {
      setLateIndentReqsLoading(true);
      Axios.get(
        `${API_BASE_URL}${GET_LATE_INDENT_REQ}?OrgId=${userDataSession.OrgId}&UserId=${userDataSession.UserId}`
      )
        .then((response) => {
          console.log(response.data, "indent list");
          if (response.data.Status) {
            setLateIndentReqsLoading(false);
            setLateIndentReqs(response.data.ResultData);
          } else {
            setLateIndentReqsLoading(false);
            console.error("Error fetching data:", response.data.Message);
          }
        })
        .catch((error) => {
          setLateIndentReqsLoading(false);
          console.error("Error fetching data:", error);
        });
    }
  };

  useEffect(() => {
    fetchLateIndents();
  }, [userDataSession]);

  const formatDateForInput = (dateString) => {
    if (!dateString) {
      console.warn("Invalid date string:", dateString);
      return "";
    }

    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      console.warn("Invalid date value:", dateString);
      return "";
    }

    const formattedDate = date.toISOString().slice(0, 16);
    return formattedDate;
  };

  // const formatDate = (dateString) => {
  //   const date = new Date(dateString);
  //   const day = String(date.getDate()).padStart(2, "0");
  //   const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  //   const year = date.getFullYear();
  //   return `${day}-${month}-${year}`;
  // };

  // const handleStoreSelectChange = (selectedOption) => {
  //   setSelectedStore(selectedOption);
  // };

  useEffect(() => {
    setLoading(true);
    const fetchDashboardData = async () => {
      try {
        const [oldDashboardResponse, countsResponse, inventoryResponse] =
          await Promise.all([
            Axios.get(
              `${API_BASE_URL}${GET_STORE_DASHBOARD}?OrgId=${userDataSession.OrgId}&UserId=${userDataSession.UserId}`
            ),
            Axios.get(
              `${API_BASE_URL}MobileSVC/getDashboardCounts?OrgId=${userDataSession.OrgId}&UserId=${userDataSession.UserId}`
            ),
            Axios.get(
              `${API_BASE_URL}${GET_DASHBOARD_TABLES_DATA}?OrgId=${
                userDataSession.OrgId
              }&StoreId=${selectedStoreId || 0}&UserId=${
                userDataSession.UserId
              }`
            ),
          ]);
        setDashboardData(oldDashboardResponse.data);
        setDashboardCounts(countsResponse.data.ResultData[0] || {});
        setInventoryData(inventoryResponse.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error(
          "Error fetching dashboard data:",
          error.response ? error.response.data : error.message
        );
      }
    };

    if (userDataSession && userDataSession.OrgId) {
      fetchDashboardData();
    }
  }, [userDataSession, selectedStoreId]);

  useEffect(() => {
    const handleStoreIdChange = (event) => {
      const storeId = event.detail;
      setSelectedStoreId(storeId);
      console.log(storeId, "localstorage storeId updated in dashboard");
    };

    window.addEventListener("storeIdChanged", handleStoreIdChange);

    // Initial check
    console.log(selectedStoreId, "initial storeId from sessionStorage");

    return () => {
      window.removeEventListener("storeIdChanged", handleStoreIdChange);
    };
  }, []);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      fetchUserPermissions();
    }
  }, [userDataSession]);

  const fetchUserPermissions = () => {
    Axios.get(
      `${API_BASE_URL}${GET_USER_PERMISSIONS}?OrgId=${userDataSession.OrgId}&RoleId=${userDataSession.RoleId}&ModuleId=0`
    )
      .then((response) => {
        // setUserPermissions(response.data.ResultData);
        sessionStorage.setItem(
          "UserPermissions",
          JSON.stringify(response.data.ResultData)
        );
        // console.log(response.data.ResultData, 'user permissonsss data....');
      })
      .catch((error) => {
        console.error("Error fetching user permissions:", error);
      });
  };

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      Axios.get(
        `${API_BASE_URL}${GET_DDL}?&LoggedInUser=${userDataSession.UserId}&OrgId=${userDataSession.OrgId}`
      )
        .then((response) => {
          if (response.data) {
            const allData = response.data.ResultData;

            const ddlNames = [
              "Supplier",
              "CATEGORY",
              "Subcategories",
              "Products",
              "variantypes",
              "TAX",
              "Stores",
              "BRAND",
              "Roles",
              "Staff",
              "Customers",
              "UNITS",
            ];

            ddlNames.forEach((name) => {
              const filteredData = allData.filter(
                (item) => item.DDLName === name
              );
              sessionStorage.setItem(
                `filteredDDLData_${name}`,
                JSON.stringify(filteredData)
              );
            });

            console.log("Filtered data saved successfully");
          } else {
            console.error("Error fetching data:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);

  const supplierData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_Supplier")
  );
  const categoryData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_CATEGORY")
  );
  const subcategoryData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_Subcategories")
  );
  const productData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_Products")
  );
  const variantypesData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_variantypes")
  );
  const taxData = JSON.parse(sessionStorage.getItem("filteredDDLData_TAX"));
  const storesData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_Stores")
  );
  const brandsData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_BRAND")
  );
  const rolesData = JSON.parse(sessionStorage.getItem("filteredDDLData_Roles"));
  const staffData = JSON.parse(sessionStorage.getItem("filteredDDLData_Staff"));
  const customerData = JSON.parse(
    sessionStorage.getItem("filteredDDLData_Customer")
  );
  const unitsData = JSON.parse(sessionStorage.getItem("filteredDDLData_UNITS"));

  useEffect(() => {
    console.log(supplierData);
    console.log(categoryData);
    console.log(subcategoryData);
    console.log(variantypesData);
    console.log(taxData);
    console.log(productData);
    console.log(brandsData);
    console.log(rolesData);
    console.log(staffData);
    console.log(storesData);
    console.log(customerData);
    console.log(unitsData);
  }, []);

  // const handleReasonChange = (event) => {
  //   setReason(event.target.value);
  // };

  // Submit late indent req
  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   if (!selectedStore || dates.length == 0) {
  //     alert("All fields are mandatory..!");
  //     return;
  //   }
  //   console.log(dates[0], dates[1]);

  //   setLateReqSubLoading(true);

  //   const requestBody = {
  //     StoreId: selectedStore.value,
  //     OrgId: userDataSession.OrgId,
  //     FromDate: dates[0],
  //     ToDate: dates[1],
  //     Reason: reason.replace(/['"]/g, ''),
  //     CreatedBy: userDataSession.UserId,
  //   };
  // console.log(requestBody, 'requestBody')
  //   Axios.post(`${API_BASE_URL}${INSERT_LATE_INDENT_REQ}`, requestBody)
  //     .then((response) => {
  //       console.log(response.data)
  //       if (response.data.ResultData[0].Status === 'Success') {
  //         setLateReqSubLoading(false);
  //         Swal.fire({
  //           title: `Indent Requested Successfully.`,
  //           icon: "success",
  //         }).then((result) => {
  //           if (result.isConfirmed || result.isDismissed) {
  //             setLateReqSubLoading(false);
  //             window.location.reload();
  //             // handleCancel();
  //           }
  //         });
  //       } else {
  //         setLateReqSubLoading(false);
  //         Swal.fire({
  //           title: "Error",
  //           text: "Failed to Request Submit.",
  //           icon: "error",
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       setLateReqSubLoading(false);
  //       console.error('Error:', error);
  //       Swal.fire({
  //         title: "Error!",
  //         text: "An error occurred while submitting the indent request.",
  //         icon: "error",
  //       });
  //     });
  // };

  // const handleCancel = () => {
  //   setReason("");
  //   setDates([]);
  //   if (storeData.length === 1) {
  //     setSelectedStore(storeData[0].StoreId);
  //   } else {
  //     setSelectedStore(null);
  //   }
  //   const offcanvasElement = document.querySelector('[data-bs-dismiss="offcanvas"]');
  //   if (offcanvasElement) {
  //     offcanvasElement.click();
  //   }
  // };

  const statusOrder = {
    1: "Request",
    2: "Approved",
    3: "Rejected",
    4: "Closed",
  };

  const statusClassNames = {
    1: "badge bg-outline-warning",
    2: "badge bg-outline-success",
    3: "badge bg-outline-danger",
    4: "badge bg-outline-secondary",
  };

  // region Columns for Most Ordered Products
  const mostOrderedColumns = [
    {
      title: "Product",
      dataIndex: "ProductName",
      key: "ProductName",
      render: (_, record) => (
        <div className="d-flex align-items-center">
          <div className="flex-fill">
            <h6 className="fs-medium text-truncate">
              <Link to="#">{record.ProductName}</Link>
            </h6>
            <p className="fs-13 d-inline-flex align-items-center">
              <span className="text-info">{record.CategoryName}</span>
              <i className="ti ti-circle-filled fs-6 text-primary mx-1" />
              {record.StoreName}
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "Count",
      dataIndex: "ProductCount",
      key: "ProductCount",
      align: "right",
      render: (_, record) => (
        <div className="text-sm-end">
          <h6 className="mb-1">{record.ProductCount}</h6>
        </div>
      ),
    },
  ];

const recentCustomersColumns = [
  {
    title: "Customer",
    dataIndex: "Name",
    key: "Name",
    render: (_, record) => (
      <div className="d-flex align-items-center">
        <div
          className="d-flex align-items-center justify-content-center me-2"
          style={{
            width: "30px",
            height: "30px",
            backgroundColor: "#007bff",
            color: "white",
            borderRadius: "15%",
            fontSize: "12px",
            fontWeight: "bold",
          }}
        >
          {record.Name.charAt(0).toUpperCase()}
        </div>
        <div className="flex-fill">
          <h6 className="fs-medium text-truncate">
            <Link to="#">{record.Name}</Link>
          </h6>
          <p className="fs-13 d-inline-flex align-items-center">
            <span className="text-info">{record.Mobile}</span>
            <i className="ti ti-circle-filled fs-6 text-primary mx-1" />
          </p>
        </div>
      </div>
    ),
  },
  {
    title: "Store",
    dataIndex: "StoreName",
    key: "StoreName",
    align: "right",
    render: (_, record) => (
      <div className="text-sm-end">
        <h6 className="mb-1">{record.StoreName}</h6>
      </div>
    ),
  },
];

  // region Columns for Recent Orders
  const recentOrdersColumns = [
    {
      title: "Order",
      dataIndex: "OrderNo",
      key: "OrderNo",
      render: (_, record) => (
        <div className="d-flex align-items-center">
          <div className="flex-fill">
            <h6 className="fs-medium text-truncate">
              <Link to="#">{record.OrderNo}</Link>
            </h6>
            <p className="fs-13 d-inline-flex align-items-center">
              <span className="text-info">{record.Orderdate}</span>
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "Amount",
      dataIndex: "Total",
      key: "Total",
      align: "right",
      render: (_, record) => (
        <div className="text-sm-end">
          <h6 className="mb-1">₹{record.Total}</h6>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="welcome d-lg-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center welcome-text">
              <h3 className="d-flex align-items-center">
                <ImageWithBasePath src="assets/img/icons/hi.svg" alt="img" />
                &nbsp;Hi {userDataSession.StoreName},
              </h3>
              &nbsp;
              <h6>here&apos;s what&apos;s happening with your store today.</h6>
            </div>
            <div
              className={`d-flex align-items-center ${
                userDataSession.RoleId === 3 && addBtnStatus === "Yes"
                  ? "d-none"
                  : "d-block"
              }`}
            >
              <button
                className="btn btn-primary"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightLateIndentReq"
                aria-controls="offcanvasRightLateIndentReq"
              >
                Request Late Indent Approval
              </button>
            </div>
          </div>
          <div className="row sales-cards justify-content-evenly">
            <div className="col-xl-3 col-sm-6 col-12">
              <Link to="/product-list">
                <div
                  className="card color-info mb-4"
                  style={{ backgroundColor: "#007bff" }}
                >
                  <img src={NoOfStores} alt="img" style={{ width: "2.7rem" }} />
                  <h4 className="text-white">
                    {" "}
                    <CountUp
                      end={
                        dashboardData && dashboardData?.counts
                          ? dashboardData.counts.TotalProducts
                          : 0
                      }
                      duration={4}
                    >
                      +
                    </CountUp>
                  </h4>
                  <p>Products</p>
                </div>
              </Link>
            </div>
            <div className="col-xl-3 col-sm-6 col-12">
              <Link to="#">
                <div
                  className="card color-info mb-4"
                  style={{ backgroundColor: "#28a745" }}
                >
                  <img src={Purchase} alt="img" style={{ width: "2.7rem" }} />
                  <h4 className="text-white">
                    <CountUp
                      end={dashboardCounts?.TodayOrderCount || 0}
                      duration={4}
                    >
                      +
                    </CountUp>
                  </h4>
                  <p>Today Orders</p>
                </div>
              </Link>
            </div>
            <div className="col-xl-3 col-sm-6 col-12">
              <div
                className="card color-info mb-4"
                style={{ backgroundColor: "#17a2b8" }}
              >
                <img
                  src={Supplier}
                  style={{ width: "2.7rem" }}
                  alt="supplier svg"
                />
                <h4 className="text-white">
                  {" "}
                  <CountUp
                    end={dashboardCounts?.TodayOrderTotal || 0}
                    duration={4}
                  >
                    +
                  </CountUp>
                </h4>
                <p>Today Sales</p>
              </div>
            </div>

            <div className="col-xl-3 col-sm-6 col-12">
              <Link to="#">
                <div
                  className="card color-info mb-4"
                  style={{ backgroundColor: "#6c757d" }}
                >
                  <img
                    src={StockValue}
                    style={{ width: "2.7rem" }}
                    alt="supplier svg"
                  />
                  <h4 className="text-white">
                    <CountUp
                      end={dashboardCounts?.MonthOrderTotal || 0}
                      duration={4}
                    >
                      +
                    </CountUp>
                  </h4>
                  <p>Monthly Sales</p>
                </div>
              </Link>
            </div>
          </div>
          {loading ? (
            <SpinLoader />
          ) : (
            <div className="row">
              {/* Recent Orders Card */}
              <div className="col-sm-12 col-md-12 col-xl-4 d-flex">
                <div className="card flex-fill default-cover w-100 mb-4">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h4 className="card-title mb-0 text-info">
                      <i className="fa-solid fa-shopping-cart me-2"></i>
                      Recent Orders
                    </h4>
                    <div className="dropdown">
                      <Link
                        to="#"
                        className="view-all d-flex align-items-center"
                      >
                        <span className="ps-2 d-flex align-items-center">
                          <i className="fa-solid fa-ellipsis text-info"></i>
                        </span>
                      </Link>
                    </div>
                  </div>
                  <div className="card-body pb-2 pt-0">
                    <Spin spinning={loading}>
                      <Table
                        columns={recentOrdersColumns}
                        dataSource={inventoryData?.RecentOrders || []}
                        pagination={false}
                        showHeader={false}
                        rowClassName={() => "mb-3"}
                      />
                    </Spin>
                  </div>
                </div>
              </div>

              {/* Most Ordered Card */}
              <div className="col-sm-12 col-md-12 col-xl-4 d-flex">
                <div className="card flex-fill default-cover w-100 mb-4">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h4 className="card-title mb-0 text-info">
                      <i className="fa-solid fa-chart-line me-2"></i>
                      Most Ordered
                    </h4>
                    <div className="dropdown">
                      <Link
                        to="#"
                        className="view-all d-flex align-items-center"
                      >
                        <span className="ps-2 d-flex align-items-center">
                          <i className="fa-solid fa-ellipsis text-info"></i>
                        </span>
                      </Link>
                    </div>
                  </div>
                  <div className="card-body pb-2 pt-0">
                    <Spin spinning={loading}>
                      <Table
                        columns={mostOrderedColumns}
                        dataSource={inventoryData?.mostOrderedProducts || []}
                        pagination={false}
                        showHeader={false}
                        rowClassName={() => "mb-3"}
                      />
                    </Spin>
                  </div>
                </div>
              </div>

              {/* Recent Customers Card */}
              <div className="col-sm-12 col-md-12 col-xl-4 d-flex">
                <div className="card flex-fill default-cover w-100 mb-4">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h4 className="card-title mb-0 text-info">
                      <i className="fa-solid fa-users me-2"></i>
                      Recent Customers
                    </h4>
                    <div className="dropdown">
                      <Link
                        to="#"
                        className="view-all d-flex align-items-center"
                      >
                        <span className="ps-2 d-flex align-items-center">
                          <i className="fa-solid fa-ellipsis text-info"></i>
                        </span>
                      </Link>
                    </div>
                  </div>
                  <div className="card-body pb-2 pt-0">
                    <Spin spinning={loading}>
                      <Table
                        columns={recentCustomersColumns}
                        dataSource={inventoryData?.recentCustomers || []}
                        pagination={false}
                        showHeader={false}
                        rowClassName={() => "mb-3"}
                      />
                    </Spin>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Late indent request */}
        {/* <div
            className="offcanvas offcanvas-end"
            tabIndex={-1}
            id="offcanvasRightLateIndentReq"
            aria-labelledby="offcanvasRightLabel"
            style={{ minWidth: '35%', maxWidth: '35%' }}
          >
            <div className="offcanvas-header d-flex align-items-center">
              <h4 id="offcanvasRightLabel" className="me-auto">Request For Late Indent</h4>
              
              <div className="d-flex align-items-center">
                <button
                  className="btn btn-primary me-2"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRightLateIndentReqView"
                  aria-controls="offcanvasRightLateIndentReqView"
                  title="View Indent Requests"
                >
                  <i className="fa-regular fa-eye fs-5"></i>
                </button>
                <button
                  type="button"
                  className="btn-close text-reset"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                  onClick={handleCancel}
                />
              </div>
            </div>

            <hr />
            <div className="offcanvas-body">
              <form onSubmit={handleSubmit}>
                <div className="row mb-2">
                  <div className="col-12 mb-3">
                    <label className="form-label">
                      Store<span className="fw-bold text-danger">*</span>
                    </label>
                    <Select
                      className="select"
                      options={
                        storeData &&
                        storeData?.map((store) => ({
                          value: store.StoreId,
                          label: store.Name,
                        }))
                      }
                      placeholder="Choose store"
                      value={selectedStore || ""}
                      onChange={handleStoreSelectChange}
                    />
                  </div>
                  <div>
                  <Space direction="vertical">
                    <Typography.Title level={5}>
                      Date<span className="fw-bold text-danger">*</span>
                    </Typography.Title>
                    <RangePicker
                      showTime={{ format: 'HH:mm' }}
                      format="YYYY-MM-DD HH:mm"
                      value={dates.length ? [moment(dates[0]), moment(dates[1])] : null}
                      onChange={(value, dateString) => {
                        if (value && value.length === 2) {
                          console.log('Selected Start Time: ', value[0]);
                          console.log('Selected End Time: ', value[1]);
                          console.log('Formatted Start Time: ', dateString[0]);
                          console.log('Formatted End Time: ', dateString[1]);
                          setDates(dateString);  // Set the formatted dates directly
                        }
                      }}
                    />
                  </Space>
                  </div>
                  <div className="mt-3">
                    <label className="form-label">Reason<span className="fw-bold text-danger">*</span></label>
                    <textarea
                      className={`form-control `}
                      placeholder="Enter reason for submitting indent outside the allowed days.."
                      rows={6}
                      value={reason}
                      onChange={handleReasonChange} 
                      required
                    ></textarea>
                  </div>
                </div>

                <div className="modal-footer-btn d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-cancel me-2"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className={`btn btn-primary me-2`}
                  >
                    {lateReqSubLoading ? 'Submitting...' : 'Submit'}
                  </button>
                </div>
              </form>
            </div>
          </div> */}

        {/* Late indents req view */}
        <div
          className="offcanvas offcanvas-end"
          tabIndex={-1}
          id="offcanvasRightLateIndentReqView"
          aria-labelledby="offcanvasRightLabel"
          style={{ minWidth: "65%", maxWidth: "65%" }}
        >
          <div className="offcanvas-header">
            <h4 id="offcanvasRightLabel">Requests of Late Indents</h4>
            <div className="d-flex ms-auto align-items-center">
              <button
                type="button"
                className="btn-close text-reset ms-2"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              />
            </div>
          </div>
          <hr />
          <div className="offcanvas-body">
            <div
              className="table-responsive"
              style={{ maxHeight: "30rem", overflowY: " auto" }}
            >
              <table className="table">
                <thead className="sticky-top">
                  <tr>
                    <th>#</th>
                    <th>Store</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Status</th>
                    <th>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {lateIndentReqsLoading ? (
                    <tr>
                      <td colSpan={12} className="text-center">
                        <div className="loader m-auto d-flex"></div>
                      </td>
                    </tr>
                  ) : (
                    lateIndentReqs?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.StoreName}</td>
                        <td>
                          <input
                            type="datetime-local"
                            className="form-control"
                            value={formatDateForInput(item.FromDate)}
                          />
                        </td>
                        <td>
                          <input
                            type="datetime-local"
                            className="form-control"
                            value={formatDateForInput(item.ToDate)}
                          />
                        </td>
                        <td>
                          <span className={statusClassNames[item.Status]}>
                            {statusOrder[item.Status]}
                          </span>
                        </td>
                        <td>
                          <Popover
                            placement="bottom"
                            title="Reason"
                            content={
                              <div
                                style={{
                                  width: "400px",
                                  maxHeight: "150px",
                                  overflowY: "auto",
                                }}
                              >
                                <p>{item.Reason}</p>
                              </div>
                            }
                            getPopupContainer={(trigger) => trigger.parentNode}
                            zIndex={1050}
                          >
                            <i
                              className="fa-regular fa-comment fs-4 text-info"
                              style={{ cursor: "pointer" }}
                            ></i>
                          </Popover>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <ApplyLateIndentReq />
      </div>
    </>
  );
};

export default StoreDashboard;
